<template>
    <b-badge v-if="item" class="e-badge-item" :class="[size]" :variant="item[variantField]" no-body>
        <slot>
            <i v-if="glyphField && item[glyphField]" class="mr-1" :class="[glyphBase, item[glyphField]]"/>
            <span>{{item[labelField]|tr}}</span>
        </slot>
    </b-badge>
</template>

<script>
    export default {
        name: `e-badge-item`,
        props: {
            item: { type: Object },
            labelField: { type: String, default: `label` },
            titleField: { type: String, default: `title` },
            glyphField: { type: String, default: `glyph` },
            glyphBase: { type: String, default: `` },
            variantField: { type: String, default: `variant` },
            size: { type: String, default: `md` }
        }
    }
</script>

<style lang="scss" scoped>
</style>
